"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableArrowLeft = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.TableArrowLeft = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, tslib_1.__assign({}, props, { width: "17", height: "17", viewBox: "0 0 50 100" }),
    React.createElement("path", { d: "M0 50L50 5L50 95L0 50Z", fill: props.fill || common_styles_1.black, stroke: props.stroke || common_styles_1.black }))); };
//# sourceMappingURL=tablearrowleft.js.map